import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    // For Products
    productLimit: 20,
    productPage: 1,
    productTotal: 0,
    productTotalPages: 1,

    // For Packages
    packageLimit: 20,
    packagePage: 1,
    packageTotal: 0,
    packageTotalPages: 1,

    // For Inventory
    inventoryLimit: 20,
    inventoryPage: 1,
    inventoryTotal: 0,
    inventoryTotalPages: 1,

    // For Reviews
    reviewLimit: 20,
    reviewPage: 1,
    reviewTotal: 0,
    reviewTotalPages: 1,

    // For Orders
    orderLimit: 20,
    orderPage: 1,
    orderTotal: 0,
    orderTotalPages: 1,
};

export const paginationSlice = createSlice({
    name: "paginationSlice",
    initialState,
    reducers: {
        // For Products
        setProductPageLimit: (state, action) => {
            state.productLimit = action.payload;
        },
        setProductCurrentPage: (state, action) => {
            state.productPage = action.payload;
        },
        setProductTotalCount: (state, action) => {
            state.productTotal = action.payload;
        },
        setProductTotalPages: (state, action) => {
            state.productTotalPages = action.payload;
        },
        resetProductPagination: (state, action) => {
            state.productLimit = 20;
            state.productPage = 1;
            state.productTotal = 0;
            state.productTotalPages = 1;
        },
        // For Packages
        setPackagePageLimit: (state, action) => {
            state.packageLimit = action.payload;
        },
        setPackageCurrentPage: (state, action) => {
            state.packagePage = action.payload;
        },
        setPackageTotalCount: (state, action) => {
            state.packageTotal = action.payload;
        },
        setPackageTotalPages: (state, action) => {
            state.packageTotalPages = action.payload;
        },
        resetPackagePagination: (state, action) => {
            state.packageLimit = 20;
            state.packagePage = 1;
            state.packageTotal = 0;
            state.packageTotalPages = 1;
        },
        // For Inventory
        setInventoryPageLimit: (state, action) => {
            state.inventoryLimit = action.payload;
        },
        setInventoryCurrentPage: (state, action) => {
            state.inventoryPage = action.payload;
        },
        setInventoryTotalCount: (state, action) => {
            state.inventoryTotal = action.payload;
        },
        setInventoryTotalPages: (state, action) => {
            state.inventoryTotalPages = action.payload;
        },
        resetInventoryPagination: (state, action) => {
            state.inventoryLimit = 20;
            state.inventoryPage = 1;
            state.inventoryTotal = 0;
            state.inventoryTotalPages = 1;
        },
        // For Reviews
        setReviewPageLimit: (state, action) => {
            state.reviewLimit = action.payload;
        },
        setReviewCurrentPage: (state, action) => {
            state.reviewPage = action.payload;
        },
        setReviewTotalCount: (state, action) => {
            state.reviewTotal = action.payload;
        },
        setReviewTotalPages: (state, action) => {
            state.reviewTotalPages = action.payload;
        },
        resetReviewPagination: (state, action) => {
            state.reviewLimit = 20;
            state.reviewPage = 1;
            state.reviewTotal = 0;
            state.reviewTotalPages = 1;
        },
        // For Orders
        setOrderPageLimit: (state, action) => {
            state.orderLimit = action.payload;
        },
        setOrderCurrentPage: (state, action) => {
            state.orderPage = action.payload;
        },
        setOrderTotalCount: (state, action) => {
            state.orderTotal = action.payload;
        },
        setOrderTotalPages: (state, action) => {
            state.orderTotalPages = action.payload;
        },
        resetOrderPagination: (state, action) => {
            state.orderLimit = 20;
            state.orderPage = 1;
            state.orderTotal = 0;
            state.orderTotalPages = 1;
        },
    },
});

export const {
    setProductPageLimit,
    setProductCurrentPage,
    setProductTotalCount,
    setProductTotalPages,
    resetProductPagination,
    setPackagePageLimit,
    setPackageCurrentPage,
    setPackageTotalCount,
    setPackageTotalPages,
    resetPackagePagination,
    setInventoryPageLimit,
    setInventoryCurrentPage,
    setInventoryTotalCount,
    setInventoryTotalPages,
    resetInventoryPagination,
    setReviewPageLimit,
    setReviewCurrentPage,
    setReviewTotalCount,
    setReviewTotalPages,
    resetReviewPagination,
    setOrderPageLimit,
    setOrderCurrentPage,
    setOrderTotalCount,
    setOrderTotalPages,
    resetOrderPagination,
} = paginationSlice.actions;

export default paginationSlice.reducer;
